import z from 'zod';

export const validationCopy = {
    email: 'Enter a valid email address (e.g., name@example.com)',
    passwordEmpty: 'Enter password',
} as const;

export const signInWithPasswordSchema = z.object({
    email: z.email(validationCopy.email).min(1, validationCopy.email),
    password: z.string().min(1, validationCopy.passwordEmpty),
});

export type SignInWithPasswordValues = z.input<typeof signInWithPasswordSchema>;
